﻿import "jquery-ui-dist/jquery-ui.js";
import "jquery-ui-dist/jquery-ui.css";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { SaveButton } from "../../../../Fundraising.UI.Shared/Modules/formTools/SaveButton";
Chart.register(ChartDataLabels);

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Dashboard = {};

    let updateRewardOptOutBtn, dashboardAnalytics;

    const setUpdateRewardOptOutBtn = () => {
        updateRewardOptOutBtn = new SaveButton(".update-reward-opt-out", {
            "savingLabel": "Updating",
            "savedLabel": "Updated"
        });
    }

    const setChart = () => {
        const chart = document.getElementById("online-sales-chart");

        if (chart && typeof dashboard_data !== 'undefined') {
            const data = {
                labels: dashboard_data.labels,
                datasets: [{
                    data: dashboard_data.data,
                    backgroundColor: dashboard_data.backgroundColors,
                    minBarLength: 1,
                    categoryPercentage: 0,
                    barPercentage: 0,
                    barThickness: 20
                }]
            };

            const options = {
                maintainAspectRatio: false,
                responsive: true,
                animation: {
                    onComplete: function (context) {
                        if (context.initial) {
                            // Render the chart again to handle the changes to the labels.
                            const chart = context.chart;
                            chart.update();
                        }
                    }
                },
                indexAxis: "y",
                scales: {
                    x: { 
                        suggestedMin: 0,
                        suggestedMax: 100,
                        ticks: {
                            callback: function (value) {
                                return '$' + value.toLocaleString();
                            }
                        }
                    },
                    y: {
                        ticks: {
                            autoSkip: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false,
                        position: 'right'
                    },
                    tooltip: {
                        enabled: true,
                        callbacks: {
                            label: function (tooltipItem) {
                                const amount = parseFloat(tooltipItem.raw);
                                const value = " $" + M2.Util.setCurrencyCommas(amount.toFixed(2));
                                return value;
                            }
                        }
                    },
                    datalabels: {
                        formatter: function (value, context) {
                            return convertToCurrency(value);
                        },
                        color: "black",
                        display: function () {
                            return (M2.Util.config.theme !== "gsa") ? true : false;
                        },
                        labels: {
                            title: {
                                weight: 'bold'
                            }
                        },
                        anchor: 'end',
                        clamp: true,
                        offset: 1,
                        align: function (context) {
                            const chart = context.chart;
                            const meta = chart.getDatasetMeta(context.datasetIndex);
                            const width = meta.data[context.dataIndex].width;
                            return width < 50 ? 'end' : 'start'
                        },
                    }, 
                }
            }

            const config = {
                type: 'bar',
                data: data,
                options: options
            };
            const ctx = chart.getContext('2d');
            dashboardAnalytics = new Chart(ctx, config);
        }
    }

    const convertToCurrency = (value) => {
        return "$" + Number.parseFloat(value).toFixed(2);
    }

    function handleOrientationChange() {
        window.addEventListener("resize", function (event) {
            removeProgressBar();
            window.setTimeout(function () {
                setThermometers();
            }, 100);
        });

    }

    function removeProgressBar() {
        $('.metric-thermometer').each(function (i, obj) {
            if ($(this).progressbar('instance') !== undefined) $(this).progressbar('destroy');
        });
    }

    const setFundraisingProgressIndicator = () => {
        const $goalThermometer = $(".fundraising-progress-thermometer");
        if ($goalThermometer) {
            const maxValue = parseInt($goalThermometer.attr("data-total"));
            let rawValue = $goalThermometer.attr('data-val');
            if (typeof rawValue === 'string') {
                if (rawValue.indexOf(',') > -1) {
                    rawValue = rawValue.replace(/,\s?/g, "");
                }
            }
            const value = parseInt(rawValue);
            $goalThermometer.progressbar({
                value: value,
                max: maxValue
            });
        }
    }

    function setThermometers() {
        $('.metric-thermometer').each(function (i, obj) {
            var maxValue = parseInt($(this).attr("data-total"));
            var rawValue = $(this).attr('data-val');
            // If it's a string remove the commas
            if (typeof rawValue === 'string') {
                if (rawValue.indexOf(',') > -1) {
                    rawValue = rawValue.replace(/,\s?/g, "");
                }
            }
            var value = parseInt(rawValue);


            $(this).progressbar({
                value: value,
                max: maxValue
            });
        });            
    }

    function setRange() {
        $(document).on("change", "#DateRangeOption", function () {
            $(this).closest("form").submit();
        });
    }

    function setMetricTrigger() {
        $(document).on('click', '.metric-trigger', function (e) {
            e.preventDefault();
            var $dashMetricContainer = $('#dashboard-metric-container');
            var $salesBreakdown = $('#sales-breakdown');
            var $campaignMetrics = $('#campaign-metrics');
            var panelIsClosed = $dashMetricContainer.hasClass('closed');

            if (panelIsClosed) {
                $dashMetricContainer.removeClass('closed');
                M2.Dashboard.displayMetrics();
            } else {
                $salesBreakdown.remove();
                $campaignMetrics.remove();
                $dashMetricContainer.addClass('closed');
            }

            //Set Arrow
            var triggerIconClass = panelIsClosed ? 'caret-up' : 'caret-down';
            var $triggerIcon = $(this).find('svg').attr('data-icon', triggerIconClass);  

            // Set Label
            var $triggerLabel = $(this).find('.trigger-label');
            var triggerLabelText = panelIsClosed ? $(this).data('label-hide') : $(this).data('label-show');
            $triggerLabel.text(triggerLabelText);
            
        });
    }

    function setCampaignPreviewLink() {

        $(document).on('click', '#verify-campaign a', function (e) {
            e.preventDefault();
            // Start the window.open immediately to get by Safari pop up blocking
            var verifyCampaignWin = window.open();
            var url = $(this).attr('href');

            $.ajax({
                url: url
            }).done(function (data) {
                var campaignURL = data.campaignUrl;
                verifyCampaignWin.location = campaignURL;
            }).fail(function () {
                alert('There was a problem generating the link to the campaign site, please try again later.');
            });
        });
    }

        function proceedPastSafetyPledge() {
            const isTrainingVideoLanding = M2.Util.exists($('div.training-video-landing'));
            if (isTrainingVideoLanding) {
                const trainingVideoPlayer = M2.Video.getPlayer('training-video-player');
                if (trainingVideoPlayer) {
                    $(document).on("click", ".proceed-past-training .btn.disabled", function (e) {
                        e.preventDefault();
                    });
                    //trainingVideoPlayer.play();
                    trainingVideoPlayer.on('ended', function () {
                        $.ajax({
                            url: $("#data-url").val()
                        }).done(function (data) {
                            $(".proceed-past-training .btn.disabled").removeClass("disabled").text("Continue");
                        });
                    });

                }
            }
    }

    function setWelcomeModalTools() {

        $(document).on("click", ".training-video-display", function (e) {
            e.preventDefault();
            const trainingVideoUrl = $(this).attr('href');
            window.parent.M2.Modal.create("training-video", "Training Video", trainingVideoUrl, "modal-lg");

            if (showState === switchState) M2.Modal.create(modalId, modalTitle, contentTarget, modalSize, isInline);


        });

        $(document).on('click', '.dismiss-welcome-modal', function (e) {
            e.preventDefault();
            const dismissModalUrl = $(this).attr('href');
            $.ajax({
                url: dismissModalUrl,
                dataType: 'json'
            }).done(function () {
                window.parent.M2.Modal.close();
            }).fail(function () {
                window.parent.M2.Modal.close();
            });
        });
    }

    M2.Dashboard = {
        config: {
            name: "M2 Dashboard"
        },
        init: function () {
            setThermometers();
            setFundraisingProgressIndicator();
            this.setSelectedGroup();
            setRange();
            setMetricTrigger();
            setCampaignPreviewLink();
            handleOrientationChange();
            proceedPastSafetyPledge();
            setWelcomeModalTools();
            setUpdateRewardOptOutBtn();
        },
        updateProfileOnSuccess: function(result) {
            // Update Profile: called on Update Profile from dashboard
            if ($("#HiddenSuccess").val() === "True") {
                M2.Modal.close();
            }
        },
        RewardOptionsOnSuccess: function (result) {
            M2.Util.setSwitches();
            setUpdateRewardOptOutBtn();
            M2.Modal.resizeParentIframe();
            updateRewardOptOutBtn.setState("saving", 300, () => {
                if ($("#FullOptOut").val() === "True") $("#physical-rewards").hide();
                updateRewardOptOutBtn.setState("saved", 1000, () => {
                    updateRewardOptOutBtn.setState("default");
                });
            });            
        },
        refreshToDoList: function () {
            if (M2.Util.exists($("#todo-list-url"))) {
                $.ajax({
                    url: $("#todo-list-url").val()
                }).done(function (data) {
                    $(".notebook").html(data);
                    if (M2.Util.exists($("#council-photo-file-wtd"))) {
                        M2.Util.uploadPhoto("#council-photo-file-wtd");
                    }
                });
            }
        },
        displayMetrics: function () {
            if (M2.Util.exists($('#salesmetrics-url'))) {
                let metricsURL = $('#salesmetrics-url').val();
                const $groupLeaderId = $("#GroupLeaderGroupId");
                const $serviceLeaderId = $("#UnitLeaderUnitId");

                if ($groupLeaderId.val()) metricsURL += "/" + $groupLeaderId.val();
                else if ($serviceLeaderId.val()) metricsURL += "/" + $serviceLeaderId.val();

                const $target = $('#dashboard-metric-container');
                $.ajax({
                    url: metricsURL,
                    beforeSend: M2.Util.displayLoad($target)
                }).done(function (data) {
                    $($target).html(data);
                    setThermometers();
                    setChart();
                    setFundraisingProgressIndicator();
                }).fail(function (request, status, error) {
                    alert('There was a problem retrieving the data.');
                    $target.empty();
                    $('.metric-tools a').trigger('click');
                });
            }
        },
        displayWelcome: function (title, url) {
            M2.Modal.create('welcome-modal', title, url, 'modal-md');
        },
        setSelectedGroup: function () {
            $(document).on("change", ".metric-filters #GroupLeaderGroupId, .metric-filters #UnitLeaderUnitId", function () {
                $("#current-level-identifier").val($(this).find('option:selected').text());
                M2.Dashboard.displayMetrics();
            });
        },
        CheckOptOut: function () {
            var troopCollection = new Array();

            $('.group input.switch-warning').each(function () {
                if (!$(this).prop("checked")) {
                    const selectedTroop = $(this).closest('.group').find('h4').html();
                    const newSelectedToop = selectedTroop.replace('Troop', '');
                    troopCollection.push(newSelectedToop);
                }
            });
        },
        manageParticipantEmailOnSuccess: function () {
            $.validator.unobtrusive.parse($("#manage-participant-email-container"));
            const success = $('#HiddenSuccess').val();
            M2.Modal.resizeParentIframe();
            if (success === 'True') {
                M2.Util.successMsg('.message-area', function () {
                    M2.Modal.resizeParentIframe();
                });
            }
        }
    };
})(jQuery);

$(function () {
    M2.Dashboard.init();
});